<template>
  <div class="c-creative">
    <div class="c-creative-wrapper g-clearfix" :style="setScrollWidth">
      <template v-if="type === 'image'">
        <creat-image
          mini
          v-for="(item, idx) in data"
          :key="idx"
          :index="idx"
          :url="item.url"
          :msg="item.msg"
          :mode="item.image_mode"
          :loading="item.loading"
          :words="words"
          :caption="title"
          @on-trend="appendTrend"
          @on-clear="clearTrend"
          @on-del-trend="deleteTrend"
          v-model="item.title"
          @on-select="appendImage"
          @on-upload="uploadImage"
          @on-delete="deleteImage"
        ></creat-image>
      </template>
      <template v-else-if="type === 'large'">
        <creat-image
          v-for="(item, idx) in data"
          :key="idx"
          :index="idx"
          :url="item.url"
          :msg="item.msg"
          :mode="item.image_mode"
          :loading="item.loading"
          :words="words"
          :caption="title"
          @on-trend="appendTrend"
          @on-clear="clearTrend"
          @on-del-trend="deleteTrend"
          v-model="item.title"
          @on-select="appendImage"
          @on-upload="uploadImage"
          @on-delete="deleteImage"
        ></creat-image>
      </template>
      <template v-else-if="type === 'group'">
        <group-image
          v-for="(item, idx) in data"
          :key="idx"
          :index="idx"
          v-model="item.title"
          :data="item.children"
          :words="words"
          :caption="title"
          @on-trend="appendTrend"
          @on-clear="clearTrend"
          @on-del-trend="deleteTrend"
          @on-select="appendImage"
          @on-upload="uploadImage"
          @on-delete="deleteImage"
        ></group-image>
      </template>
      <template v-else-if="type === 'video'">
        <creat-video
          v-for="(item, idx) in data"
          :key="idx"
          :index="idx"
          :data="item.children"
          v-model="item.title"
          :words="words"
          :caption="title"
          @on-trend="appendTrend"
          @on-clear="clearTrend"
          @on-del-trend="deleteTrend"
          @on-play="playVideo"
          @on-select="appendImage"
          @on-loading="loadingImage"
          @on-upload="uploadImage"
          @on-delete="deleteImage"
        ></creat-video>
      </template>
    </div>
  </div>
</template>
<script>
import CreatImage from '@/components/creative/creat-image.vue'
import CreatVideo from '@/components/creative/creat-video.vue'
import GroupImage from '@/components/creative/group-image.vue'

export default {
  name: 'creative',
  components: { GroupImage, CreatVideo, CreatImage },
  props: {
    data: {
      type: Array
    },
    type: {
      type: String
    },
    title: {
      type: Boolean,
      default() {
        return false
      }
    },
    words: {
      type: Array
    }
  },
  computed: {
    setScrollWidth() {
      let width
      if (this.type === 'image') width = 248
      else if (this.type === 'large') width = 369
      else if (this.type === 'group') width = 560
      else if (this.type === 'video') width = 526
      return { width: `${this.data.length * width}px` }
    }
  },
  methods: {
    appendImage(index) {
      if (this.type === 'group') {
        if (index.idx) index = [index.index, index.idx]
      } else if (this.type === 'video' && index.idx) index = [index.index, index.idx]
      this.$emit('on-select', { type: this.type, index })
    },
    uploadImage(params) {
      const { index, file, vertical, idx } = params
      this.$emit('on-upload', { type: this.type, index, idx, file, vertical })
    },
    loadingImage(params) {
      const { index, idx } = params
      this.$emit('on-loading', { type: this.type, index, idx })
    },
    deleteImage(index) {
      this.$emit('on-delete', { type: this.type, index })
    },
    appendTrend(trend) {
      this.$emit('on-trend', Object.assign({}, trend, { type: this.type }))
    },
    clearTrend(index) {
      this.$emit('on-clear', { type: this.type, index })
    },
    deleteTrend(params) {
      const { index, order } = params
      this.$emit('on-del-trend', { type: this.type, index, order })
    },
    playVideo(url) {
      window.open(url, '_blank')
    }
  }
}
</script>
<style lang="scss" scoped>
.c-creative {
  width: 100%;
  overflow-x: auto;
  scrollbar-width: thin;
  -webkit-overflow-scrolling: touch;

  padding: 8px 0;

  ::v-deep .ivu-btn {
    margin-right: 5px;
  }
}
</style>
